import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"
import Button from '../button/index'
import { HeaderWrapper, LogosWrapper, MenuWrapper, HamburguerMenuButton } from './style'
import LogoFicaAzul from '../../images/logos/ficaazul-negativo.svg'
import LogoCredPago from '../../images/logos/credpago-negativa.svg'
import globals from '../globals'

const Hamburguer = props => {
  return (
    <div className="hamburger-box">
      <div className="hamburger-inner"></div>
    </div>
  )
}

const Header = ({ siteTitle, withBackground, paintHeader }) => {

  const [ isMenuOpen, setMenuOpen ] = useState( false )
  const appWasReleased = process.env.GATSBY_APP_WAS_RELEASED === "true"

  return (
    <HeaderWrapper withBackground={withBackground} paintHeader={paintHeader}>
      <LogosWrapper>
        <li>
          <Link to="/">
            <img width={125} src={LogoFicaAzul} alt="Fica Azul" />
          </Link>
        </li>
        <li>
          <a href="//credpago.com.br">
            <img width={102} src={LogoCredPago} alt="Um produto CredPago" />
          </a>
        </li>
      </LogosWrapper>
      <MenuWrapper withBackground={withBackground} isMenuOpen={isMenuOpen}>
        <HamburguerMenuButton size="large" isActive={isMenuOpen} onClick={() => setMenuOpen(!isMenuOpen)} className="menu-toggle" type="ghost">
          <Hamburguer />
        </HamburguerMenuButton>
        <ul>
          <li className="dot"><Link to="/faq">FAQ | Dúvidas Frequentes</Link></li>
          {appWasReleased && (
            <li className="dot"><a href={`${globals.externals.app}/solicitar-cadastro`}>Cadastrar Empresa</a></li>
          )}          
          <li className="dot"><Link to="/contato">Contato</Link></li>
          {appWasReleased && (
            <li>
              <Button 
                onClick={() => window.location = `${globals.externals.app}/login`}
                type="ghost">Login</Button>
            </li>
          )}
          
        </ul>
      </MenuWrapper>
    </HeaderWrapper>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
  withBackground: PropTypes.bool
}

Header.defaultProps = {
  siteTitle: ``,
  withBackground: false
}

export default Header
